module.exports = __webpack_public_path__ + "static/img/879_phase_function_Paper_Points.38c7283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/879_phase_function_Paper_Points.png
// module id = A26T
// module chunks = 0